import React from 'react';

interface FeatureSectionProps {
  title: string;
  bgColor: string;
  textColor: string;
  children: React.ReactNode;
  className?: string;
}

export const FeatureSection: React.FC<FeatureSectionProps> = ({
  title,
  bgColor,
  textColor,
  children,
  className = ""
}) => {
  return (
    <div className={`space-y-2 ${className}`}>
      <div className={`px-3 py-2 ${bgColor} ${textColor} rounded-md inline-block`}>
        {title}
      </div>
      <div className="ml-4">
        {children}
      </div>
    </div>
  );
}; 